<template>
    <div>
        <div v-for="(v, i) in list" :key="v.ID">
            <hallOrderRecord :obj="v" :class="i%2 == 0 ? 'even-part' : ''"
                             @clickGoDetail="clickGoDetailback"
                             @clickDelete = "clickDeleteback"
            />
        </div>
    </div>
</template>

<script setup>
    import HallOrderRecord from "@/components/shopchart/hallOrderRecord.vue";

    const props = defineProps(["list"])
    const emits = defineEmits(["clickGoDetail"])

    function clickGoDetailback(ref, companycode) {
        emits("clickGoDetail", ref, companycode)
    }

    function clickDeleteback(ref) {
      emits("clickDelete", ref)
    }

</script>

<style scoped>
    .even-part {
        background: #F5F7FA;
    }
</style>